






































































































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue, Watch } from 'vue-property-decorator';
import SpaceTypeDetailDialog from '@/modules/company/components/district/components/SpaceTypeDetailDialog.vue';
import SpaceTypeCreateDialog from '@/modules/company/components/district/components/SpaceTypeCreateDialog.vue';
import CardWithTitle from '@/modules/_common/components/CardWithTitle.vue';
import store from '@/store';
import companyDistrictService from '@/services/company-district.service';
import {
  CompanyDistrictDto,
  SpaceTypeSearchDto,
  SpaceTypePatchDto,
} from '@/dto/company-district';
import { Pagination } from '@/core';
import { SpaceTypeDto } from '@/dto/company-district/space-type.dto';
import { YN } from '@/services/shared';
import { getColor } from '@/modules/_common/utils/getColor';

@Component({
  name: 'DistrictDetail',
  components: {
    CardWithTitle,
    SpaceTypeDetailDialog,
    SpaceTypeCreateDialog,
  },
})
export default class DistrictDetail extends BaseComponent {
  private companyDistrictDto = new CompanyDistrictDto();
  private detailLoading = false;
  private spaceTypeSearchDto = new SpaceTypeSearchDto();
  private spaceTypePatchDto = new SpaceTypePatchDto();
  private spaceTypeDtoList: SpaceTypeDto[] = [];
  private pagination = new Pagination(8);
  private spaceTypeListCount: number = null;
  private typeListLoading = false;
  private spaceTypeDetailDialog = false;
  private spaceTypeCreateDialog = false;
  private spaceTypeNo: number | string | string[] = null;
  get pageCount(): number {
    return Math.ceil(this.spaceTypeListCount / this.pagination.limit);
  }
  @Watch('pagination', {
    deep: true,
  })
  paginationChanged() {
    this.getSpaceTypeList();
  }

  getColor(status) {
    return getColor(status);
  }

  getDistrict() {
    this.detailLoading = true;
    companyDistrictService.findOne(this.$route.params.id).subscribe(res => {
      this.companyDistrictDto = res.data;
      this.setMap(res.data);
      this.detailLoading = false;
    });
  }
  getSpaceTypeList() {
    this.typeListLoading = true;
    this.spaceTypeSearchDto.companyDistrictNo = this.$route.params.id;

    companyDistrictService
      .findDistrictSpaceTypeList(this.spaceTypeSearchDto, this.pagination)
      .subscribe(res => {
        this.typeListLoading = false;
        this.spaceTypeDtoList = res.data.items;
        this.spaceTypeListCount = res.data.totalCount;
      });
  }
  formerPage() {
    if (this.pagination.page > 1) {
      this.pagination.page--;
    }
  }
  nextPage() {
    if (this.pagination.page < this.pageCount) {
      this.pagination.page++;
    }
  }
  showSpaceTypeDetailDialog(no: number) {
    this.spaceTypeDetailDialog = true;
    this.spaceTypeNo = no;
  }
  toggleShow(no: number, showYN: YN) {
    this.spaceTypePatchDto.showYn = showYN;
    companyDistrictService
      .patchDistrictSpaceType(no, this.spaceTypePatchDto)
      .subscribe(res => {
        // if (res.data.delYn === YN.Y) {
        //   this.$toasted.info(
        //     '나누다키친의 심사가 끝나지않아 노출되지 않습니다',
        //   );
        // }
        this.getSpaceTypeList();
      });
  }
  // 지도 가져오기
  setMap(district: CompanyDistrictDto) {
    const mapContainer = document.getElementById('map'),
      mapOption = {
        center: new window.kakao.maps.LatLng(district.lat, district.lon),
        level: 3,
        mapTypeId: window.kakao.maps.MapTypeId.ROADMAP,
      };

    const map = new window.kakao.maps.Map(mapContainer, mapOption);
    const markerPosition = new window.kakao.maps.LatLng(
      district.lat,
      district.lon,
    );
    const marker = new window.kakao.maps.Marker({
      position: markerPosition,
    });
    marker.setMap(map);
  }
  created() {
    // console.log('companyDetail mounted');
    this.getDistrict();
    this.getSpaceTypeList();
  }
}
